import React from 'react';
import { EntityFieldList } from './'
function InsideFolder(props) {
    return <React.Fragment>
        <EntityFieldList {...props} insideVlaue={true}/>
    </React.Fragment>
}

export default InsideFolder;